import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=35750e93&scoped=true&"
import script from "./Index.vue.js?vue&type=script&lang=js&"
export * from "./Index.vue.js?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=35750e93&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35750e93",
  null
  
)

export default component.exports